$(document).ready(function() {
  const $counterContent = $('.modal-card__counter-content');

  if ($counterContent.length) {
    const getNumWord = (number, titles) => {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }

    const getCounterTimer = () => {
      const date = new Date();
      let hours = 23 - date.getHours();
      let minutes = 59 - date.getMinutes();
      let seconds = 59 - date.getSeconds();

      const prettyHours = hours < 10 ? `0${hours}` : hours
      const prettyMinutes = minutes < 10 ? `0${minutes}` : minutes
      const prettySeconds = seconds < 10 ? `0${seconds}` : seconds

      const $content = $(`
        <div>
          <div class="modal-card__counter-item">
            <span class="modal-card__counter-value">${prettyHours}</span>
            <span class="modal-card__counter-label">${getNumWord(hours, ['час', 'часа', 'часов'])}</span>
          </div>
          <div class="modal-card__counter-item">
            <span class="modal-card__counter-value">${prettyMinutes}</span>
            <span class="modal-card__counter-label">${getNumWord(minutes, ['минута', 'минуты', 'минут'])}</span>
          </div>
          <div class="modal-card__counter-item">
            <span class="modal-card__counter-value">${prettySeconds}</span>
            <span class="modal-card__counter-label">${getNumWord(seconds, ['секунда', 'секунды', 'секунд'])}</span>
          </div>
        </div>
      `)

      $counterContent.html($content.html());
    }

    getCounterTimer();

    setInterval(() => {
      getCounterTimer();
    }, 1000)
  }

})

